import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { supabase } from "./supabaseClient";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Show from "./pages/Show";
import Movie from "./pages/Movie";
import Blogs from "./pages/Blogs";
import BlogPost from "./pages/BlogPost";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";

function ProtectedRoute({ session, children }) {
  const location = useLocation();

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

export default function App() {
  const [session, setSession] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const loadSession = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (!mounted) return;

      setSession(session || null);
      setAuthLoading(false);
    };

    loadSession();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session || null);
      setAuthLoading(false);
    });

    return () => {
      mounted = false;
      subscription.unsubscribe();
    };
  }, []);

  if (authLoading) {
    return (
      <div className="grid min-h-screen place-items-center bg-[#0f0202] text-white">
        Loading...
      </div>
    );
  }

  return (
    <>
      {session ? <Header session={session} /> : null}

      <Routes>
        <Route
          path="/login"
          element={session ? <Navigate to="/home" replace /> : <Login />}
        />

        <Route
          path="/"
          element={
            <ProtectedRoute session={session}>
              <Home />
            </ProtectedRoute>
          }
        />

        <Route
          path="/home"
          element={
            <ProtectedRoute session={session}>
              <Home />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute session={session}>
              <Profile session={session} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/blogs"
          element={
            <ProtectedRoute session={session}>
              <Blogs />
            </ProtectedRoute>
          }
        />

        <Route
          path="/blogs/:slug"
          element={
            <ProtectedRoute session={session}>
              <BlogPost />
            </ProtectedRoute>
          }
        />

        <Route
          path="/show/:showId/:episodeId"
          element={
            <ProtectedRoute session={session}>
              <Show />
            </ProtectedRoute>
          }
        />

        <Route
          path="/show/:showId"
          element={
            <ProtectedRoute session={session}>
              <Show />
            </ProtectedRoute>
          }
        />

        <Route
          path="/movie/:movieId"
          element={
            <ProtectedRoute session={session}>
              <Movie />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin"
          element={
            <ProtectedRoute session={session}>
              <Admin session={session} />
            </ProtectedRoute>
          }
        />

        <Route
          path="*"
          element={<Navigate to={session ? "/home" : "/login"} replace />}
        />
      </Routes>

      {session ? <Footer /> : null}
    </>
  );
}
